"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const order_list_1 = require("../order-list");
const styled_1 = require("./styled");
const Column = props => {
    const { status, items, onEdit } = props;
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledContainer, { children: [(0, jsx_runtime_1.jsx)(styled_1.StyledHeader, { component: "h5", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `enums.orderStatus.${status}` }) }), (0, jsx_runtime_1.jsx)(order_list_1.OrderList, { listId: status, items: items, onEdit: onEdit })] }));
};
exports.Column = Column;
//# sourceMappingURL=index.js.map